import React from 'react'
import Navbar from "../../Components/Navbar/Navbar";
import UnderstandingOur2 from '../../Components/PrivacyPolicySection/UnderstandingOur2/UnderstandingOur2';
import PolicyOverview from '../../Components/PrivacyPolicySection/PolicyOverview/PolicyOverview';
const PrivacyPolicyPage = ({ header, isVisible, footerData }) => {
    return (
        <>
            <div>
                <div>
                    <Navbar header={header} isVisible={isVisible} />
                    <div>
                        <UnderstandingOur2 />
                    </div>
                    <div>
                        <PolicyOverview/>
                    </div>
                </div>

            </div>
        </>
    )
}

export default PrivacyPolicyPage
